const CSV_INJECTION = /^[\\+=@-]+/;
function exportHeaders({ headers, }) {
    return headers
        .filter((column) => !column.disableExport && column.isVisible)
        .map((column) => {
        if (column.exportHeader) {
            return column.exportHeader(column);
        }
        return column.render("Header");
    })
        .join(",");
}
function defaultExportCell(cell) {
    if (Array.isArray(cell.value)) {
        return cell.value.join(",");
    }
    return cell.value;
}
function sanitizeString(value) {
    return value.replace(CSV_INJECTION, "").replace(/"/g, '""');
}
function exportRows({ prepareRow, rows, }) {
    return rows
        .map((row) => {
        prepareRow(row);
        return row.cells
            .filter((cell) => !cell.column.disableExport)
            .map((cell) => {
            var _a, _b, _c, _d, _e, _f;
            const value = (_f = (_c = (_b = (_a = cell.column).cellToString) === null || _b === void 0 ? void 0 : _b.call(_a, { row, value: cell.value })) !== null && _c !== void 0 ? _c : (_e = (_d = cell.column).export) === null || _e === void 0 ? void 0 : _e.call(_d, cell)) !== null && _f !== void 0 ? _f : defaultExportCell(cell);
            if (typeof value === "string") {
                return `"${sanitizeString(value)}"`;
            }
            return value;
        })
            .join(",");
    })
        .join("\n");
}
function prepareCSV(tableInstance) {
    const { headers, prepareRow, preGroupedRows } = tableInstance;
    const exportedHeaders = exportHeaders({ headers });
    const exportedRows = exportRows({
        prepareRow,
        rows: preGroupedRows,
    });
    return `${exportedHeaders}\n${exportedRows}`;
}
function makeCSV(tableInstance) {
    return new Blob([prepareCSV(tableInstance)], {
        type: "text/csv;charset=utf-8;",
    });
}

export { makeCSV as default, prepareCSV };
//# sourceMappingURL=makeCSV.esm.js.map
